import de from '@assets/language/DE3.png'
import es from '@assets/language/ES.png'
import fr from '@assets/language/PM.png'
import en from '@assets/language/US.png'

export interface AvailableLanguageInterface {
  id: string
  name: string
  label: string
  image: string
}

export const availableLanguages: AvailableLanguageInterface[] = [
  {
    id: 'en',
    name: 'English',
    label: 'EN',
    image: en,
  },
  {
    id: 'de',
    name: 'Deutsch',
    label: 'DE',
    image: de,
  },
  {
    id: 'fr',
    name: 'Français',
    label: 'FR',
    image: fr,
  },
  {
    id: 'es',
    name: 'Español',
    label: 'ES',
    image: es,
  },
]
